import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      setEmail("");
      toast.success("You're subscribed! Watch your inbox.");
    } catch (err) {
      toast.error("Please enter a valid email address.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="aqua-section" data-testid="newsletter-section">
      <div className="aqua-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="rounded-3xl p-8 sm:p-12 text-center"
          style={{ backgroundColor: "#EAF3FF" }}
        >
          <span
            className="w-14 h-14 rounded-2xl mx-auto flex items-center justify-center"
            style={{ backgroundColor: "#1E7BE0" }}
          >
            <Mail className="w-6 h-6 text-white" />
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold mt-5 text-[#0B2F6B]">
            Join the Agua Flow family.
          </h2>
          <p className="mt-3 text-[#3B5878] max-w-xl mx-auto leading-relaxed">
            Get seasonal session dates, water-safety tips, and first access to our
            upcoming CPR &amp; First Aid programs — straight to your inbox.
          </p>
          {done ? (
            <div
              className="mt-6 inline-flex items-center gap-2 text-[#1E7BE0] font-semibold"
              data-testid="newsletter-success"
            >
              <CheckCircle2 className="w-5 h-5" /> Thanks for subscribing!
            </div>
          ) : (
            <form
              onSubmit={submit}
              className="mt-7 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
              data-testid="newsletter-form"
            >
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                data-testid="newsletter-email"
                className="flex-1 rounded-full border border-[#DCE7F5] bg-white px-5 py-3 text-[#0B2F6B] outline-none focus:border-[#33BED6] focus:ring-2 focus:ring-[#33BED6]/30"
              />
              <button
                type="submit"
                disabled={submitting}
                data-testid="newsletter-submit"
                className="btn-primary disabled:opacity-60"
              >
                {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
              </button>
            </form>
          )}
        </motion.div>
      </div>
    </section>
  );
}
